import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { createBaseQuery } from "../helper/createBaseQuery";

const attachmentApi = createApi({
  reducerPath: "attachment",
  baseQuery: createBaseQuery(),
  tagTypes: ["Attachment"],
  endpoints(builder) {
    return {
      // GET

      // getAttachment: builder.query({
      //   query: () => ({
      //     url: `Attachment/GetAttachments`,
      //     method: "GET",
      //   }),
      //   providesTags: ["Attachment"],
      // }),

      getAttachment: builder.query({
        query: (args) => {
          const { sourceId, reference, sourceType } = args;
          return {
            url: `Attachment?sourceId=${sourceId}&reference=${reference}&sourceType=${sourceType}`,
          };
        },
        providesTags: ["Attachment"],
      }),

      // getAttachmentDownload: builder.query({
      //   query: (attachmentId) => {
      //     return {
      //       url: `Attachment/${attachmentId}`,
      //     };
      //   },
      //   providesTags: ["Attachment"],
      // }),

      // POST

      postSaveAttachment: builder.mutation({
        query: (data) => ({
          url: "Attachment",
          method: "POST",
          body: data,
        }),
        invalidatesTags: ["Attachment"],
      }),

      getAttachmentDownload: builder.mutation({
        query: (data) => ({
          url: "Attachment/Get",
          method: "POST",
          body: data,
        }),
        invalidatesTags: ["Attachment"],
      }),

      // DELETE
      deleteAttachment: builder.mutation({
        query: (attachmentId) => ({
          url: `Attachment/${attachmentId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Attachment"],
      }),
    };
  },
});

export const {
  usePostSaveAttachmentMutation,
  useGetAttachmentQuery,
  useDeleteAttachmentMutation,
  // useGetAttachmentDownloadQuery,
  useGetAttachmentDownloadMutation
} = attachmentApi;
export { attachmentApi };
